'use client';

import Image from 'next/image';
import Link from 'next/link';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Heading } from '../ui/heading';
import { Paragraph } from '../ui/paragraph';
import { Button } from '../ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { SheetClose } from '../ui/sheet';

export function RegisterSuccess({ inDialog }: { inDialog?: boolean }) {
  const { t } = useTranslations();

  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center gap-8',
        !inDialog && 'pb-12 pt-48 sm:pb-16 sm:pt-52 lg:pt-64',
      )}
    >
      <div className="flex w-full flex-col items-center justify-center gap-6">
        <Image
          src={'/images/icons/success.svg'}
          alt={t('text3750')}
          height={48}
          width={48}
          className="shrink-0 object-contain"
        />
        <Heading title={t('text3401')} center tag="h4" />
        <Paragraph size="base" className="w-full max-w-[370px] text-center" color="neutral">
          {t('text3402')}
        </Paragraph>
      </div>
      <div className="grid w-full grid-cols-1 gap-3 sm:flex sm:items-center sm:justify-center">
        <SheetClose asChild>
          <Button asChild className="col-span-1 w-full sm:w-fit">
            <Link prefetch={false} href={ROUTES.PROFILE()}>
              {t('text1134')}
            </Link>
          </Button>
        </SheetClose>
        <SheetClose asChild>
          <Button asChild variant={'white'} className="col-span-1 w-full sm:w-fit">
            <Link prefetch={false} href={ROUTES.HOME()}>
              {t('text2379')}
            </Link>
          </Button>
        </SheetClose>
      </div>
    </div>
  );
}
